import { call, put, select } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import {
  previewFileClosed,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { requestActivePanelWhiteboardDataSaga } from 'features/content-whiteboard/sagas/requestActivePanelWhiteboardDataSaga';

export function* reconcilePresentContentLibraryPermissionsSaga() {
  const canPresent: boolean = yield call(hasPermissionsSaga, PermissionTypes.presentContentLibrary);

  if (canPresent) {
    return;
  }

  const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

  if (!previewedFile) {
    return;
  }

  yield put(previewFileClosed());
  yield call(requestActivePanelWhiteboardDataSaga);
}
